import {Component, inject, Input} from '@angular/core';
import {NgForm} from '@angular/forms';
import {IndividualFormComponent} from '../individual-form/individual-form.component';
import {CompanyFormComponent} from '../company-form/company-form.component';
import {CooperativeFormComponent} from '../cooperative-form/cooperative-form.component';
import {BUSINESS_FORM} from '../business-form.token';
import {AddBusinessFormData} from '../add-business-form-data';

@Component({
  selector: 'app-business-form-card',
  imports: [
    IndividualFormComponent,
    CompanyFormComponent,
    CooperativeFormComponent
  ],
  templateUrl: './business-form-card.component.html',
  styleUrl: './business-form-card.component.scss'
})
export class BusinessFormCardComponent {
  protected formData: AddBusinessFormData = inject(BUSINESS_FORM);

  @Input() form?: NgForm;
}
